import { useSelector } from 'react-redux';

const showroomAliasID = 4;

export default () => {
    const aliasId = useSelector(state => state.application.aliasId);

    return showroomAliasID === aliasId;
};
